export default "__VITE_ASSET__B2RIQ7Lx__"